import { IconProps } from 'components/icons/Icons.types';
import React from 'react';
import styles from './Icon.module.scss';

const EyeSlashIcon: React.FC<IconProps> = ({
  className = '',
  size = 24,
  color = '#fffff0',
  fillColor = 'transparent',
  fillOpacity = 1,
  circleStrokeColor = '#fffff0',
}) => {
  const baseCls = `${styles.IconContainer} ${className}`;
  return (
    <div className={baseCls}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="transparent" xmlns="http://www.w3.org/2000/svg">
        <circle
          fill={fillColor}
          fillOpacity={fillOpacity}
          cx="12"
          cy="12"
          r="10.5"
          stroke={circleStrokeColor}
          strokeWidth={'1.5px'}
        />

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M 18.12,6.32 C 13.7,9.63 9.22,12.88 4.76,16.15 a 0.72,0.72 0 0 0 -0.15,1 0.72,0.72 0 0 0 1,0.15 C 10.07,14.04 14.54,10.78 18.98,7.47 a 0.72,0.72 0 0 0 0.14,-1 0.72,0.72 0 0 0 -1,-0.14 z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m12 5.5c3.2 0 6.3 1.9 7.7 4.7.3.6.5 1.1.7 1.7-.8 3.2-3.5 5.8-6.8 6.3-3 .7-6.3-.5-8.2-2.9-.8-.9-1.4-2.1-1.7-3.3.8-3.2 3.5-5.7 6.7-6.3.5-.1 1-.1 1.6-.1zM12 17c-3 .1-5.9-2-6.8-4.9.1-.8.6-1.6 1.1-2.3 1.8-2.4 5.1-3.4 7.9-2.5 2.2.7 4 2.5 4.6 4.7-.9 2.9-3.7 5.1-6.8 5Zm2.9-5c.1 1.6-1.5 3.1-3.2 2.9-1.6-.2-2.9-1.9-2.5-3.5.3-1.6 2.1-2.7 3.6-2.1 1.2.3 2.1 1.5 2.1 2.7Zm-1.4 0c.1 1-1.2 1.8-2.1 1.3s-1-1.9-.1-2.5c.9-.7 2.3.1 2.2 1.2z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default EyeSlashIcon;
